import { Button } from './Button';
import { cn } from '@/lib/cn';

/**
 * Reproduces the tab-button-row pattern used twice in the legacy
 * PharmacyModule.jsx (main tabs, procurement sub-tabs): the active tab is
 * `btn-primary`, everything else is `btn-ghost`. Deliberately not a full
 * ARIA tabs widget (Radix Tabs, roving tabindex, arrow-key navigation) —
 * that is not what the legacy screen does, and adding that interaction
 * model would be a real behaviour change, not a faithful migration.
 */
export interface TabBarProps<T extends string> {
  tabs: ReadonlyArray<{ id: T; label: string }>;
  active: T;
  onChange: (id: T) => void;
  size?: 'md' | 'sm';
  className?: string;
}

export function TabBar<T extends string>({ tabs, active, onChange, size = 'md', className }: TabBarProps<T>) {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {tabs.map((t) => (
        <Button key={t.id} variant={active === t.id ? 'primary' : 'ghost'} size={size} onClick={() => onChange(t.id)}>
          {t.label}
        </Button>
      ))}
    </div>
  );
}
